export default __webpack_public_path__ + "static/media/kotlin.fe963619.png";